import { render } from "./StoryDisplay.vue?vue&type=template&id=58f6588e&scoped=true"
import script from "./StoryDisplay.vue?vue&type=script&lang=js"
export * from "./StoryDisplay.vue?vue&type=script&lang=js"

import "./StoryDisplay.vue?vue&type=style&index=0&id=58f6588e&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.34_vue@3.5.34_webpack@5.107.1_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f6588e"]])

export default __exports__